// src/components/StripePayment.tsx
import { createSignal, onMount } from "solid-js";

export const StripePayment = ( props: { clientSecret: string, result: ( paymentIntent: any, err: any ) => Promise<void> } ) => {
	let formRef!: HTMLFormElement;
	let elementRef!: HTMLDivElement;

	const [paying, setPaying] = createSignal( false );

	onMount( async () => {
		const { loadStripe } = await import( "@stripe/stripe-js" ); // ⬅️ dynamic import here
		const stripePromise = loadStripe( "pk_test_51SXPGTLiTAL3tJwaR7iap9BwFlnHH5J5LKVjb5iUPxtwa08GU6GXiyWcQzwMwFS30smStzOsIH7BRHr3uxd7RSjP00FmtHr2az" );

		const stripe = await stripePromise;
		if ( !stripe ) return;

		const elements = stripe.elements( { clientSecret: props.clientSecret } );
		const paymentElement = elements.create( "payment" );
		paymentElement.mount( elementRef );

		formRef.addEventListener( "submit", async ( e ) => {
			e.preventDefault();

			setPaying( true );

			const { error, paymentIntent } = await stripe.confirmPayment( {
				elements,
				redirect: "if_required",
				confirmParams: {
					return_url: window.location.origin + "/dashboard/success",
				},
			} );

			await props.result( paymentIntent, error );

			setPaying( false );
		} );
	} );

	return (
		<form ref={formRef}>
			<div ref={elementRef}></div>

			<button type="submit" class="w-full mt-4 px-4 py-2 bg-primary text-white rounded disabled:bg-gray-700" disabled={paying()}>
				Pay
				<svg viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg" class="ml-3 w-7.5 h-7.5 animate-spin" classList={{ "hidden": !paying(),"inline-block": paying() }}>
					<circle class="spin" cx="400" cy="400" fill="none"
						r="200" stroke-width="50" stroke="#fff"
						stroke-dasharray="700 1400"
						stroke-linecap="round" />
				</svg>
			</button>
		</form>
	);
}
